import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AppContext";
import { LeadProvider } from "@/context/LeadDialog";
import Layout from "@/components/Layout";
import WhatsAppButton from "@/components/WhatsAppButton";
import ChatWidget from "@/components/ChatWidget";
import { captureRefFromUrl } from "@/lib/referral";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Ingredients from "@/pages/Ingredients";
import Journal from "@/pages/Journal";
import JournalArticle from "@/pages/JournalArticle";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import Quality from "@/pages/Quality";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";
import AuthCallback from "@/pages/AuthCallback";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  React.useEffect(() => { captureRefFromUrl(); }, []);
  // Detect Emergent OAuth callback synchronously during render — MUST precede any /auth/me check
  if (location.hash?.includes("session_id=")) {
    return (
      <Layout>
        <AuthCallback />
        <WhatsAppButton />
      </Layout>
    );
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:category" element={<Shop />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/ingredients" element={<Ingredients />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/journal/:slug" element={<JournalArticle />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/quality" element={<Quality />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/account" element={<Account />} />
      </Routes>
      <WhatsAppButton />
      <ChatWidget />
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <LeadProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <AppRouter />
        </BrowserRouter>
      </LeadProvider>
    </AuthProvider>
  );
}
